import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

// Favorites (star/unstar) API. Server: /api/v1/favorite
export const favoriteApi = createApi({
  reducerPath: 'favoriteApi',
  baseQuery: baseQuery(),
  tagTypes: ['Favorite'],
  endpoints: (builder) => ({
    // list favorited entities, optionally filtered by type ('Project' | 'Image' | 'Result')
    listFavorites: builder.query({
      query: (entityType?: string) => ({
        url: `/favorite${entityType ? `?entityType=${entityType}` : ''}`,
      }),
      providesTags: ['Favorite'],
    }),
    starEntity: builder.mutation({
      query: ({ entityId, entityType }) => ({
        url: `/favorite`,
        method: 'POST',
        body: { entityId, entityType },
      }),
      invalidatesTags: ['Favorite'],
    }),
    unstarEntity: builder.mutation({
      query: ({ entityId }) => ({
        url: `/favorite`,
        method: 'DELETE',
        body: { entityId },
      }),
      invalidatesTags: ['Favorite'],
    }),
  }),
});

export const {
  useListFavoritesQuery,
  useStarEntityMutation,
  useUnstarEntityMutation,
} = favoriteApi;

export default favoriteApi;
